<template>
  <shit-shell title="Today">
    <shit-todo v-for="shit in shits" :key="shit.uuid" :shit="shit" ref="shits"/>
  </shit-shell>
</template>

<script>
import ShitShell from '../components/ShitShell'
import ShitTodo from '../components/ShitTodo'

export default {
  components: {
    ShitShell,
    ShitTodo
  },
  data () {
    return {
      shits: [
        {
          description: 'hac habitasse platea +dictumst'
        },
        {
          description: 'nibh +venenatis cras sed'
        },
        {
          description: '#sodales ut eu sem'
        },
        {
          description: 'mattis molestie a /iaculis'
        },
        {
          description: 'sit amet cursus sit',
          completedAt: new Date()
        },
        {
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        },
        {
          description: 'semper eget duis at tellus at urna condimentum mattis pellentesque id'
        },
        {
          description: 'nec ultrices dui sapien eget mi proin'
        }
      ]
    }
  }
}
</script>
